import { hasOwnProperty } from "./object.mjs";
import { isArray, isArrayLike, isExist, isObject } from "./is.mjs";
import { isDefined } from "./guards.mjs";
export const toArray = (value) => {
  if (!isDefined(value))
    return [];
  if (isArray(value))
    return value;
  if (isArrayLike(value))
    return Array.prototype.slice.call(value);
  return [value];
};
export function range(...args) {
  let start, stop, step;
  if (args.length === 1) {
    start = 0;
    step = 1;
    [stop] = args;
  } else {
    ;
    [start, stop, step = 1] = args;
  }
  const arr = [];
  let current = start;
  while (current < stop) {
    arr.push(current);
    current += step || 1;
  }
  return arr;
}
export const chuck = (array, length) => {
  const chucks = [];
  array.forEach((item, index) => {
    const chuckIndex = index % length;
    if (!chucks[chuckIndex]) {
      chucks[chuckIndex] = [];
    }
    chucks[chuckIndex].push(item);
  });
  return chucks;
};
export function without(array, ...args) {
  let transform;
  let ignoreItems;
  const [_ignoreItems, options] = args;
  const isRealOptions = isObject(options) && hasOwnProperty(options, "transform");
  if (!options || !isRealOptions) {
    transform = (item) => item;
    ignoreItems = isArray(_ignoreItems) ? _ignoreItems : args;
  } else if (isRealOptions) {
    transform = options.transform;
    ignoreItems = toArray(_ignoreItems);
  }
  return array.filter((item) => !ignoreItems.includes(transform(item)));
}
export const groupBy = (array, transform) => {
  return array.reduce((group, item) => {
    const key = transform(item);
    group[key] = group[key] || [];
    group[key].push(item);
    return group;
  }, {});
};
export const join = (array, separator, transform = (item) => item) => {
  return array.map(transform).filter(isExist).join(separator);
};
export function at(array, index) {
  const length = array.length;
  if (!length)
    return void 0;
  if (index < 0)
    index += length;
  return array[index];
}
export function last(array) {
  return at(array, -1);
}
export const shuffle = (array) => {
  const copy = [...array];
  for (let i = copy.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [copy[i], copy[j]] = [copy[j], copy[i]];
  }
  return copy;
};
export const pickRandom = (array, n) => {
  const shuffledArray = shuffle(array);
  return shuffledArray.slice(0, n);
};
export const uniq = (array, transform = (item) => item) => {
  const map = new Map();
  array.forEach((item) => {
    const key = transform(item);
    if (!map.has(key)) {
      map.set(key, item);
    }
  });
  return Array.from(map.values());
};
